/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Stack, Text} from '@chakra-ui/react'
import {useCurrentBasket} from '../../../hooks/use-current-basket'
import CartOrderProductCount from './cart-order-product-count'

const CartTitle = () => {
    const {
        derivedData: {totalItems}
    } = useCurrentBasket()
    return (
        <Stack spacing={4}>
            <Text textStyle="Regular 45XLarge">
                <FormattedMessage defaultMessage="Your cart" id="cart_title.title.cart_title" />
            </Text>
            <CartOrderProductCount totalItems={totalItems} textStyle="Semi Bold Medium" />
        </Stack>
    )
}

export default CartTitle
